import { Link } from "react-router-dom";
import logoNew from "../../assets/logo-new.png";
import "./authShell.css";

function AuthShell({
  topBarPrompt,
  topBarCtaLabel,
  topBarCtaTo,
  children,
}) {
  return (
    <section className="auth-shell">
      <div className="auth-shell__orb auth-shell__orb--one" />
      <div className="auth-shell__orb auth-shell__orb--two" />

      <div className="auth-shell__frame">
        <div className="auth-shell__topbar">
          <Link to="/home" className="auth-shell__logo" aria-label="EMALPHA home">
            <img src={logoNew} alt="EMALPHA" loading="lazy" />
          </Link>

          <div className="auth-shell__switch">
            {topBarPrompt ? (
              <p className="auth-shell__switch-copy">{topBarPrompt}</p>
            ) : null}
            {topBarCtaLabel && topBarCtaTo ? (
              <Link to={topBarCtaTo} className="auth-shell__switch-link">
                {topBarCtaLabel}
              </Link>
            ) : null}
          </div>
        </div>

        <div className="auth-shell__content">
          <div className="auth-card">{children}</div>
        </div>
      </div>
    </section>
  );
}

export default AuthShell;
